<template>
    <v-container>
        <v-card-title style="border-bottom: 1px solid rgba(255,0,0,0.2)" class="mb-4 pt-1 pb-1">
            <h2>Nova Chamada</h2>
        </v-card-title>

        <!-- CALL INFOS -->
        <v-row>
            <v-col>
                <!-- INFO CALL -->
                <v-container class="call-main-info" v-if="callSelected">
<!--                    {{ chamadaAtual }}-->
                    <v-row>
                        <v-col cols="6" class="col-main-info" style="border-radius: 6px 0 0 0;">
                            <div class="outbound-call" v-if="callSelected.tipoChamada === 'efetuada'">
                                <strong>Agente</strong>
                                <p class="pl-2 pt-1 mb-1">
                                    <!--                                                        {{exampleCall.cnam}} - {{exampleCall.cnum}}-->
                                    {{callSelected.extensao ? callSelected.extensao : 'Agente'}} - {{callSelected.canais[1]}}
                                </p>
                            </div>
                            <div v-else class="inbound-call">
                                <strong>Cliente</strong>
                                <p class="pl-2 pt-1 mb-1">
                                    <!--                                                        {{client[0].Entidade}} - {{client[0].Nome}}-->
                                    {{ callSelected.numeroCliente }}
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="6" class="col-main-info" style="border-radius: 0 6px 0 0;">
                            <strong>Data/Hora</strong>
                            <p class="pl-2 pt-1 mb-1">
                                <v-icon color="warning" size="20" class="pr-1">mdi-calendar</v-icon>
                                <!-- Data e hora -->
                                {{ callDate }}
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="col-main-info" style="border-radius: 0 0 0 6px;">
                            <div v-if="callSelected.tipoChamada === 'efetuada'">
                                <!-- Cliente para se ligou -->
                                <strong>Destinatário</strong>
                                <p class="pl-2 mb-1">
                                    <v-icon color="info" size="20" class="pr-1">mdi-phone</v-icon>
                                    {{callSelected.numeroCliente}}
                                 </p>
                            </div>
                            <div v-else>
                                <!-- Agente que atendeu -->
                                <strong>Agente</strong>
                                <p class="pl-2 pt-1 mb-1">{{callSelected.extensao ? callSelected.extensao : 'Agente'}}</p>
                            </div>
                        </v-col>
                        <v-col cols="6" class="col-main-info" style="border-radius: 0 0 6px 0;">
                            <v-row>
                                <v-col class="pb-0">
                                    <strong>Cliente Associado</strong>
                                </v-col>
                                <v-col class="pb-0" style="display: flex; justify-content: flex-end; ">
                                    <v-checkbox
                                            class="ml-2"
                                            v-model="isClientFinal"
                                            @change="selectedClient={}"
                                            label="Cliente Final"
                                            dense
                                    ></v-checkbox>
                                </v-col>
                            </v-row>


                            <!-- AUTOCOMPLETE PARA SELECIONAR CLIENTE -->
                            <v-autocomplete
                                    v-if="!isClientFinal"
                                    :items="clientsList"
                                    item-text="Cliente"
                                    item-value="Cliente"
                                    v-model="selectedClient"
                                    return-object
                                    :filter="filterClients"
                                    outlined dense hide-details
                                    label="Cliente"
                            >
                                <template v-slot:item="{ item }">
                                        {{ item.Cliente }} - <span class="pl-1" style="font-size: 12px">{{ item.Nome }}</span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    {{ item.Cliente }} - <span class="pl-1" style="font-size: 12px">{{ item.Nome }}</span>
                                </template>
                            </v-autocomplete>

                            <v-text-field
                                    label="Nome Cliente"
                                    dense outlined hide-details
                                    v-else-if="isClientFinal"
                                    v-model="clientFinalName"
                            />
                        </v-col>
                    </v-row>
                </v-container>

                <!-- OBSERVATIONS -->
                <v-container class="mt-2" style="padding: 12px 20px;">
                    <h4 class="pl-2">Observações</h4>
                    <!-- INJECT TEXT-FIELD TO SAVE INFORMATION -->
                    <v-textarea
                            v-model="callObservation"
                            class="mb-1"
                            counter outlined
                    ></v-textarea>
                </v-container>
            </v-col>
        </v-row>

        <v-card-actions>
            <v-btn color="info" small width="250px" @click="closeDialog">
                <v-icon class="mr-1" size="20">mdi-close</v-icon>
                Fechar
            </v-btn>
            <v-spacer/>
            <v-btn color="success" small width="500px" @click="saveCallInteraction" :disabled="validateForm">
                <v-icon class="mr-1" size="20">mdi-content-save</v-icon>
                GUARDAR
            </v-btn>
        </v-card-actions>
    </v-container>
</template>

<script>
export default {
    props: {
        chamadaAtual: Object
    },
    data: () => ({
        loading: false,
        loadingClients: false,
        callSelected: {},
        callObservation: '',
        actualDate: '',
        callDate: '',
        clientsList: [],
        selectedClient: {},
        isClientFinal: '',
        clientFinalName: ''
    }),
    mounted() {
        //Open
        this.playEffectSound();
        //Debug
        this.debug();

        this.callDate = this.chamadaAtual.timestamp.substring(0, 10) + ' ' + this.chamadaAtual.timestamp.substring(11, 19);
        this.getClients();
    },
    methods: {
        debug(){
            //Debug
            this.callSelected = this.chamadaAtual;
        },
        //Objetivo, criar metodo para criar um novo registo de interaction_call
        saveCallInteraction() {
            let loader = this.$loading.show();
            //Variables to manage values
            let callInteraction = {
                client: '',
                clientPhone: '',
                date: '',
                agent: '',
                observations:''
            }

            //Check if store or finalClient
            if (this.isClientFinal){
                callInteraction.client = this.clientFinalName
                callInteraction.entity = '';
            }else{
                callInteraction.entity = this.selectedClient.Cliente
                callInteraction.client = this.selectedClient.Nome
            }

            //Fill variable -> campo callSelected.agente, no caso de efetuada, guarda o 244575195, caso recebida guarda o mesmo valor da extensao
            callInteraction.clientPhone = this.callSelected.numeroCliente
            callInteraction.agent = this.callSelected.extensao
            callInteraction.date = this.callDate
            callInteraction.observations = this.callObservation
            callInteraction.uniqueid = this.callSelected.linkedId
            callInteraction.type = this.callSelected.tipoChamada
            callInteraction.finalClient = this.isClientFinal ? 1 : 0

            //Send values to api, to store on interaction_call
            // console.log(callInteraction);
            // console.log(this.callSelected);

            let request = {
                url: '/api/staff/customer-service/interaction-call',
                data: {
                    interaction: callInteraction,
                }
            };

            ApiWS.dispatch('makePost', request)
                    .then(response => {
                        loader.hide();
                        let responseData = response.data;

                        if (responseData.status === 'OK'){

                            Alert.dispatch('show', {
                                snackbar: true,
                                text: 'Guardado com sucesso!',
                                type: 'success'
                            })
                            this.closeDialog();
                        }

                    })
                    .catch(() => {
                        loader.hide();
                        Alert.dispatch('show', {
                            snackbar: true,
                            text: 'Erro de servidor!',
                            type: 'error'
                        })
                    })
        },

        //Obter lista de clientes para ser possivel fazerem associação da chamada um cliente
        getClients() {
            this.loadingClients = true;

            let request = {
                url: '/api/staff/clientsBicimax'
            }

            ApiWS.dispatch('makeGet', request)
                    .then(response => {
                        let responseData = response.data;
                        if (responseData.status === 'OK') {
                            this.clientsList = responseData.clients;
                        }
                        this.loadingClients = false;

                    })
                    .catch(() => {
                        this.loadingClients = false;
                    })
        },

        //Fechar dialog parent
        closeDialog() {
            this.$emit('close-new-call', false);
        },

        //Sound PopUp
        playEffectSound(){
            var audio = new Audio('/pop-up-sound.mp3'); // path to file
            audio.play().catch(err => {
                console.log(err)
            });
        },

        filterClients(item, queryText, itemText){
            return (
                    item.Nome.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.Cliente.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
            );
        }
    },
    computed:{
        validateForm(){
            if (this.clientFinalName === '' && this.isClientFinal){
                return true;
            }
            if (!this.isClientFinal && !this.selectedClient.Cliente){
                return true;
            }
            return false;
        }
    }
}

</script>

<style scoped>
.call-main-info {
    padding: 12px 28px;

    .col-main-info {
        border: 1px solid rgba(0, 0, 0, 0.4);
    }
}
</style>